import { AHSeparator, Box, useTheme } from "arkh";
import React, { useMemo } from "react";
import { KPITeamGroup } from "../Edit/KPITeamGroup";
import {
  KPISectionGoalListItem,
  KPISectionListItem,
} from "./KPISectionListItem";
import { SectionSubItemContainer } from "./SectionSubItemContainer";

export function KPITeamGroupListItem({
  teamGroup,
  goalDirection,
  hasGoal,
}: {
  teamGroup: KPITeamGroup;
  hasGoal: boolean;
  goalDirection: "greater" | "less";
}) {
  const theme = useTheme();
  const team = {
    id: teamGroup.teamId,
    icon: teamGroup.icon,
    color: teamGroup.color,
    name: teamGroup.name,
  };

  const subTeams = useMemo(() => {
    return teamGroup.subTeams
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [teamGroup]);

  if (hasGoal) {
    return (
      <Box key={teamGroup.sectionId} color="surface">
        {teamGroup.subTeams.length === 0 ? (
          <KPISectionGoalListItem
            spaceHorizontal="none"
            goalDirection={goalDirection}
            goalValue={teamGroup.goalValue}
            team={team}
            style={{ minHeight: 0 }}
          />
        ) : (
          <KPISectionListItem
            style={{ paddingBottom: 0, minHeight: 0 }}
            team={team}
          />
        )}
        {subTeams.map((subTeam, i) => (
          <SectionSubItemContainer
            key={i}
            isLast={i === teamGroup.subTeams.length - 1}
            color={teamGroup.color ?? theme.primary}
            spaceLeft="medium"
          >
            {i > 0 ? <AHSeparator /> : null}
            <KPISectionGoalListItem
              spaceHorizontal="none"
              name={subTeam.name}
              goalDirection={goalDirection}
              goalValue={subTeam.goalValue}
            />
          </SectionSubItemContainer>
        ))}
      </Box>
    );
  }

  return (
    <Box key={teamGroup.sectionId} color="surface">
      <KPISectionListItem
        team={team}
        name={teamGroup.name}
        style={[
          teamGroup.subTeams.length > 0
            ? {
                paddingBottom: 0,
                minHeight: 0,
              }
            : {},
        ]}
      />
      {subTeams.map((subTeam, i) => (
        <SectionSubItemContainer
          key={i}
          isLast={i === teamGroup.subTeams.length - 1}
          color={teamGroup.color ?? theme.primary}
          spaceLeft="medium"
        >
          <KPISectionListItem name={subTeam.name} />
          <AHSeparator />
        </SectionSubItemContainer>
      ))}
    </Box>
  );
}
